module.exports = __webpack_public_path__ + "static/media/TAPNYSwagDesign2.07f5d1f2.jpeg";